import {
  InAppMessageActionEvent,
  InAppMessageCloseEvent,
  InAppMessageEvent,
  InAppMessageImpressionEvent
} from "./InAppMessageEvent"
import { InAppMessageView } from "../view/InAppMessageView"
import { HackleInAppMessageActionImpl } from "../../../../core/internal/model/model"
import { InAppMessageActionHandlerFactory } from "./InAppMessageActionHandler"

export interface InAppMessageEventProcessor<Event extends InAppMessageEvent> {
  supports(event: InAppMessageEvent): boolean

  process(view: InAppMessageView, event: Event, timestamp: number): void
}

export class InAppMessageEventProcessorFactory {
  constructor(private readonly processors: InAppMessageEventProcessor<InAppMessageEvent>[]) {}

  get(event: InAppMessageEvent): InAppMessageEventProcessor<InAppMessageEvent> | undefined {
    return this.processors.find((it) => it.supports(event))
  }
}

export class InAppMessageImpressionEventProcessor implements InAppMessageEventProcessor<InAppMessageImpressionEvent> {
  process(view: InAppMessageView, event: InAppMessageImpressionEvent, timestamp: number): void {
    // Do nothing
  }

  supports(event: InAppMessageEvent): boolean {
    return event.type === "IMPRESSION"
  }
}

export class InAppMessageCloseEventProcessor implements InAppMessageEventProcessor<InAppMessageCloseEvent> {
  process(view: InAppMessageView, event: InAppMessageCloseEvent, timestamp: number): void {
    // Do nothing. This method is called after the view is closed.
  }

  supports(event: InAppMessageEvent): boolean {
    return event.type === "CLOSE"
  }
}

export class InAppMessageActionEventProcessor implements InAppMessageEventProcessor<InAppMessageActionEvent> {
  constructor(private readonly actionHandlerFactory: InAppMessageActionHandlerFactory) {}

  process(view: InAppMessageView, event: InAppMessageActionEvent, timestamp: number): void {
    const handler = this.actionHandlerFactory.get(event.action)
    const processed = view.ui.inAppMessageListener?.onInAppMessageClick?.(
      view.context.inAppMessage,
      view,
      HackleInAppMessageActionImpl.fromAction(event.action)
    )
    if (processed || !view.status.canClose()) return

    handler?.handle(view, event.action)
  }

  supports(event: InAppMessageEvent): boolean {
    return event.type === "ACTION"
  }
}
